import axios from "axios";
import serverUrl from "../utils/utilsser";

const api = axios.create({
  baseURL: serverUrl,
});

//login
export const login = async (email, code, password) => {
  try {
    const response = await api.post(`api/v1/auth/login`, {
      email,
      code,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

//fetch users using filter

export const fetchUsers = async (code, filter) => {
  try {
    const response = await api.get(`api/v1/users/total/${code}`, {
      params: { filter },
    });
   
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};


export const fetchReferralUserCount = async (referalCode) => {
  try {
    const response = await api.get(`api/v1/coupon/user-count/${referalCode}`);
  
    return response.data;
  } catch (error) {
    console.error("Error fetching referral user count:", error);
    throw error;
  }
};
 
// Optional: total across a parent org + all its child codes
// (uses the /user-count/org/:parent endpoint)
export const fetchOrgUserCount = async (parent) => {
  try {
    const response = await api.get(`api/v1/coupon/user-count/org/${parent}`);
   
    return response.data;
  } catch (error) {
    console.error("Error fetching org user count:", error);
    throw error;
  }
};
 

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

//feth the follwed community count

export const fetchCommunityData = async (code) => {
  try {
    const response = await api.get(`api/v1/community/count/A`);

    return response.data;
  } catch (error) {
    console.error("Error fetching community data:", error);
    throw error;
  }
};

//features count

export const getTestCount = async (code) => {
  const response = await api.get(`api/v1/features/test-count/${code}`);
  return response.data;
};

export const getMoodCount = async (code) => {
  const response = await api.get(`api/v1/features/mood-count/${code}`);
  return response.data;
};

export const getSelfCareCount = async (code) => {
  const response = await api.get(`api/v1/features/self-count/${code}`);
  return response.data;
};

//issues

export const fetchIssuesData = async (code) => {
  try {
    const response = await api.get(`api/v1/issues/users/${code}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching issues data:", error);
    throw error;
  }
};

//feedback
export const getFeedback = async (code) => {
  try {
    const response = await api.get(`api/v1/feedback/getFeedback/${code}`);
    return response.data.feedbacks;
  } catch (error) {
    console.error("Error fetching feedback:", error);
    throw error;
  }
};

export const getIssueInsight = async (code) => {
  try {
    const response = await api.get(`api/v1/issuesInsight/users/${code}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Issue Insight:", error);
    throw error;
  }
};

export default api;
